import { adminComponents } from './admin.js'
import { presetCategoryComponents } from './preset-category.js'
import { presetComponents } from './preset.js'
import { pricingSettingsComponents } from './pricing-settings.js'
import { recipeComponents } from './recipe.js'

export const adminGeneratedComponents = [
  ...adminComponents,
  ...presetComponents,
  ...pricingSettingsComponents,
  ...presetCategoryComponents,
  ...recipeComponents,
]
